import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { UserService } from '../_services';
import * as CurrentUserActions from '../_actions/currentUser';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserEffects {
  // Effetto per impostare l'utente corrente
  setCurrentUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CurrentUserActions.setCurrentUser),
      mergeMap(({ user }) =>
        this.userService.getUser().pipe(
          map(() => CurrentUserActions.setCurrentUserSuccess({ user })),
          catchError((error) => of(CurrentUserActions.setCurrentUserFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private userService: UserService
  ) {}
}
